import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import { IAuthStore, TSavedUrl } from 'redux/reducers/auth/types';

// ==========================================:
const getAuthState = (state: TStoreState): IAuthStore => state.auth;
export const getAuth = createSelector([getAuthState], (auth: IAuthStore) => auth);

// ====================================================:
export const getIsAuth = createSelector([getAuth], (auth: IAuthStore): boolean => {
	return !!auth.accessToken;
});

// ====================================================:

export const getAuthAccessToken = createSelector(
	[getAuth],
	(auth: IAuthStore): string | null => auth.accessToken,
);

// ====================================================:
export const getAuthIsAuthenticated = createSelector(
	[getAuth],
	(auth: IAuthStore): boolean => !!(auth.isAuthenticated && auth.accessToken),
);

// ====================================================:
export const getAuthIsNotAuthenticated = createSelector(
	[getAuth],
	(auth: IAuthStore): boolean => !auth.isAuthenticated && !auth.accessToken,
);
// ====================================================:
export const getIsLoad = createSelector([getAuth], (auth: IAuthStore): boolean => auth.loginLoader);

// ==========================================:

export const getSavedUrl = createSelector(
	[getAuthState],
	(auth: IAuthStore): TSavedUrl => auth.savedUrl,
);
